import { handleError } from './utils';

export const editUser = (data, history) => handleError(async (dispatch, getState, { api }) => {
  dispatch({ type: 'BEGIN_OPERATION' });
  api.editUser(data, history);
}, 'There was a problem when trying to edit profile');

export const getAllUserData = () => handleError(async (dispatch, getState, { api }) => {
  await api.getAllUserData();
});
